export const createHash = function(string = '') {
    let hash = 0;
    let i;
    let chr;
    if (string.length === 0) return Math.abs(hash).toString(16);
    for (i = 0; i < string.length; i++) {
        chr = string.charCodeAt(i);
        hash = ((hash << 5) - hash) + chr;
        hash |= 0;
    }
    return Math.abs(hash).toString(16);
};
